module.exports = __webpack_public_path__ + "img/1.28f8ed51.jpg";